"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductStatus = exports.ProductStockStatus = void 0;
const product_variant_types_1 = require("./product-variant-types");
const measurement_units_1 = require("./constants/measurement-units");
var ProductStockStatus;
(function (ProductStockStatus) {
    ProductStockStatus["HIGH"] = "high";
    ProductStockStatus["MEDIUM"] = "medium";
    ProductStockStatus["LOW"] = "low";
    ProductStockStatus["OUT_OF_STOCK"] = "out_of_stock";
    ProductStockStatus["UNTRACKABLE"] = "untrackable";
})(ProductStockStatus = exports.ProductStockStatus || (exports.ProductStockStatus = {}));
var ProductStatus;
(function (ProductStatus) {
    ProductStatus["ACTIVE"] = "active";
    ProductStatus["INACTIVE"] = "inactive";
})(ProductStatus = exports.ProductStatus || (exports.ProductStatus = {}));
const exampleTemplate = {
    name: "Product 1",
    categories: [
        {
            name: "sub",
            isVisibleInMenu: true,
            description: "blblbl",
            logo: {
                url: "https://www.google.com/qwe.png",
                description: "This is a description",
            },
            createdAt: new Date(),
            productsCount: 0,
            parent: {
                name: "parent",
                isVisibleInMenu: true,
                description: "blblbl",
                logo: {
                    url: "https://www.google.com/qwe.png",
                    description: "This is a description",
                },
                createdAt: new Date(),
                productsCount: 0,
            },
        },
    ],
    supplier: {
        name: "Supplier 1",
        email: "supplier@example.com",
        dropshipping: false,
        payeeAccounts: [],
        createdAt: new Date(),
        contacts: [],
        currency: "GBP",
    },
    brand: {
        createdAt: new Date(),
        logo: {
            url: "https://www.google.com/qwe.png",
            description: "This is a description",
        },
        name: "Brand 1",
        productsCount: 0,
    },
    publishedDate: new Date(),
    status: ProductStatus.ACTIVE,
    statusSettings: {
        high: 10,
        low: 0,
    },
    variants: [
        {
            createdAt: new Date(),
            inventoryInfo: {
                soldCount: 0,
                barcode: "123456789",
                customFields: [{ name: "Custom", value: "CustomValue" }],
                qty: 75,
                status: ProductStockStatus.HIGH,
                committedQty: 10,
                incomingQty: 15,
                reservedQty: 3,
                shelf: "A",
                warehouse: "C",
                alley: "B",
            },
            productOptionConfig: [
                {
                    option: {
                        name: "Color",
                        values: ["Red", "Blue"],
                        createdAt: new Date(),
                    },
                    optionValue: "Red",
                },
            ],
            minOrderQty: 10,
            maxOrderQty: 20,
            pricing: {
                GBP: {
                    price: "1.00",
                    priceWithVAT: "1.20",
                    VAT: 20,
                    isClientBasedPrice: false,
                    discounts: [
                        {
                            discount: 10,
                            discountDateEnd: new Date(),
                            discountDateStart: new Date(),
                        },
                    ],
                },
                USD: {
                    price: "9.00",
                    priceWithVAT: "10.00",
                    VAT: 15,
                    isClientBasedPrice: false,
                    discounts: [
                        {
                            discount: 0,
                            discountDateEnd: new Date(),
                            discountDateStart: new Date(),
                        },
                    ],
                },
                EUR: {
                    price: "15.00",
                    priceWithVAT: "25.00",
                    VAT: 99,
                    isClientBasedPrice: false,
                    discounts: [
                        {
                            discount: 0,
                            discountDateEnd: new Date(),
                            discountDateStart: new Date(),
                        },
                    ],
                },
            },
            deliveryInfo: {
                packagingItems: 1,
                volume: "2",
                volumeUnit: measurement_units_1.MeasurementUnits.LITRES,
                deliveryTime: product_variant_types_1.ProductDeliveryTime.DAYS_3_5,
                weight: "2",
                weightUnit: measurement_units_1.MeasurementUnits.KILOGRAMS,
                height: "2",
                heightUnit: measurement_units_1.MeasurementUnits.CENTIMETERS,
                length: "2",
                lengthUnit: measurement_units_1.MeasurementUnits.CENTIMETERS,
                width: "2",
                widthUnit: measurement_units_1.MeasurementUnits.CENTIMETERS,
                postageCost: "0.50",
                shippingCost: "1.20",
            },
            description: "This is a product description",
            images: [
                {
                    url: "https://www.google.com/qwe.png",
                    description: "This is a description",
                },
            ],
            shortDescription: "This is a short description",
            sku: "123456789",
        },
    ],
    createdAt: new Date(),
    options: [{ name: "Color", values: ["Red", "Blue"], createdAt: new Date() }],
    isSellable: true,
    isTrackable: true,
    allowListingOnMobile: true,
};
